import React, { useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable, Draggable, DropResult } from "react-beautiful-dnd";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import toast from "react-hot-toast";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import moment from "moment";
import Drawer from '../../../components/Drawer';
import CreateWorkOrder from "../../WorkOrder/_components/createWorkOrder";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import ScheduleModalWorkOrder from "../../WorkOrder/_components/schedulepopupWorkOrder";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import InprogressModalWorkOrder from "../../WorkOrder/_components/inprogresspopupWorkOrder";
import CompleteIncompleteModalWorkOrder from "../../WorkOrder/_components/completeincompletepopupWorkOrder";
import Icon from "../../../components/icons";
import Button from "../../../components/elements/button";
import CancelModalWorkOrder from "../../WorkOrder/_components/cancelpopupWorkOrder";
import CancelWorkRequestSidebar from "./cancelWorkRequestSidebar";
import { Dropdown, Menu } from "../../../components/Dropdown";
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { useFacilityManagersSelector } from '../../../store/selectors/masterSelector';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import { useUserSelector } from '../../../store/selectors/userSelector';
import { getPermissionInfo } from '../../../_common/functions';
import { useLocation } from 'react-router-dom';

interface KanbanViewProps {
    _ref?: any;
    onCreateWR?: () => void;
    onFilterWR?: (filter: any) => void;
    canEdit?: boolean;
}

type Task = {
    id: string;
    content: any;
};

type Column = {
    id: string;
    title: string;
    dbid: any; // dbid for the column, if needed
    workRequestStatusHexCode: string; //work request hex code
    taskIds: string[];
};

type KanbanData = {
    tasks: Record<string, Task>;
    columns: Record<string, Column>;
    columnOrder: string[];
};

// Custom column title mapping - override API titles with these
const COLUMN_TITLE_MAPPING: Record<number, string> = {
    1: "New",
    2: "Task Created",  // Changed from "Work order Created"
    3: "Assigned",
    4: "Scheduled",
    5: "In Progress",
    6: "Closed",
};

// Helper function to get column title - uses custom mapping if available, otherwise API title
const getColumnTitle = (statusID: number, apiTitle: string): string => {
    return COLUMN_TITLE_MAPPING[statusID] || apiTitle;
};

const initialData: KanbanData = {    
    tasks: {},
    columns: {
        "column-1": {
            id: "column-1",
            title: "New",    
            dbid: 1, // Example dbid for the column    
            workRequestStatusHexCode: `#333333`,    
            taskIds: [],
        },
        "column-2": {
            id: "column-2",
            title: "Work Order Created",
            dbid: 2, // Example dbid for the column        
            workRequestStatusHexCode: `#333333`,    
            taskIds: [],
        },
        "column-3": {
            id: "column-3",
            title: "Assigned",
            dbid: 3, // Example dbid for the column
            workRequestStatusHexCode: `#333333`,    
            taskIds: [],
        },
        "column-4": {
            id: "column-4",
            title: "Scheduled",
            dbid: 4, // Example dbid for the column
            workRequestStatusHexCode: `#333333`,    
            taskIds: [],
        },
        "column-5": {
            id: "column-5",
            title: "In Progress",
            dbid: 5, // Example dbid for the column
            workRequestStatusHexCode: `#333333`,    
            taskIds: [],
        },
        "column-6": {
            id: "column-6",
            title: "Closed",
            dbid: 6, // Example dbid for the column
            workRequestStatusHexCode: `#333333`,    
            taskIds: [],
        },
    },
    columnOrder: ["column-1", "column-2", "column-3","column-4", "column-5", "column-6"],
};

const KanbanView: React.FC <KanbanViewProps> = ({ _ref, canEdit = true }) => {    
    const workRequestAPI: any = useWorkRequestApi();
    const workOrderAPI: any = useWorkOrderApi();
    const checklistAPI: any = useChecklistApi();
    const facilityApi: any = useFacilitiesApi();
    const commonApi: any = useCommonApi();

    const createWODrwerWORef = useRef<any>();
    const createKBWORef = useRef<any>();
    const assignscheduleWODrwerWORef = useRef<any>();
    const assignscheduleKBRef = useRef<any>();
    const inprogressWODrwerWORef = useRef<any>();
    const inproressKBRef = useRef<any>();
    const completeincompleteWODrwerWORef = useRef<any>();
    const completeincompleteKBRef = useRef<any>();
    const cancelWODrwerWORef = useRef<any>();
    const cancelKBRef = useRef<any>();
    const cancelWRDrawerRef = useRef<any>();
    const cancelWRKBRef = useRef<any>();
    const filtersRef = useRef<any>();
    
    const closecancelmodalRef = useRef<any>(null);
    

    const { showLoader, hideLoader } = useAppLoader();
    const users = useFacilityManagersSelector();
    const loggedinuser: any = useUserSelector();
    const location = useLocation();

    const [data, setData] = useState<KanbanData>(initialData);
    const [isloaded, setIsLoaded] = useState<boolean>(false);
    const [statusList, setStatusList] = useState<any[]>([]);
    const [processingTask, setProcessingTask] = useState<string | null>(null);
    const [isAssignonly, setIsAssignonly] = useState<boolean>(false);
    const [creatwodatapreparation, setCreatwodatapreparation] = useState<any>(null);
    const [assignwodatapreparation, setAssignwodatapreparation] = useState<any>(null);
    const [cancelwrdatapreparation, setCancelwrdatapreparation] = useState<any>(null);
    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [closefiltermode, setClosefiltermode] = useState<any>(30); 
    const [willcancel, setWillcancel] = useState<any>(`wo`);
    
    // Filter related states
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [priority, setPriority] = useState<any>([]);
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    const GetWorkRequestByID = async (WRID: any) => {
        showLoader();
        const wrdetails = await new Promise((resolve, reject) => {
            workRequestAPI.GetWorkRequestByID({ WorkRequestID: WRID }, async (data: any) => {            
                var woassetsmap = [];
                var checklistmap: any = [];
                if (data?.workRequestMappingList && Array.isArray(data?.workRequestMappingList)) {
                    woassetsmap = data?.workRequestMappingList.map((item: any) => {
                        return {
                            woAssetMappingID: item?.wrAssetMappingID,
                            workOrderID: null,
                            assetID: item?.assetID,
                            assetCode: item?.assetCode,
                            name: item?.assetName,
                            statusID: item?.statusID,
                            statusName: item?.statusName,
                            vehicleLastInspection: item?.vehicleLastInspection,
                            warrantyEndDate: item?.warrantyEndDate
                        }
                    });

                    var assetIDs: any = data?.workRequestMappingList.map((o: any) => o.assetID);
                    if (assetIDs.length > 0) {
                        checklistmap = await new Promise((resolve, reject) => {
                            checklistAPI.getChecklists({ assetIDs: assetIDs }, (resp: any) => {
                                if (resp && resp.hasOwnProperty('checklistList') && Array.isArray(resp.checklistList) && resp.checklistList.length > 0) {
                                    resolve(resp.checklistList);
                                } else {
                                    resolve([]);
                                }
                            }, (error: any) => {
                                reject([]);
                            });
                        }).catch((error: any) => { });
                    }
                }

                const wrimagesresp = await new Promise((resolve, rejects) => {
                    workRequestAPI.GetWorkRequestImages({ workRequestID: WRID }, (resp: any) => {
                        resolve((resp && resp?.files) ? resp?.files : []);
                    }, (error: any) => {
                        rejects([]);
                    });
                }).catch((error: any) => { return []; });

                const prefillData_wo = {
                    model: {
                        workRequestID: data?.workRequestID,
                        description: data?.description,
                        facilityID: data?.facilityID,
                        subFacilityID: data?.subFacilityID,
                        workRequestPriorityID: data?.workRequestPriorityID,
                    },
                    assets: woassetsmap,
                    checklist: checklistmap,
                    images: wrimagesresp
                };
                resolve(prefillData_wo);                
            }, (error: any) => {
                reject(null)
            });
        }).catch((error: any) => { 
            return null;
        });
        console.log("GetWorkRequestByID resp =>", wrdetails);
        setCreatwodatapreparation(wrdetails);
        hideLoader();        
    };

    const GetWorkOrderDetails = async (id: string) => {       
        showLoader(); 
        const wodata = await new Promise((resolve, reject) => {
            workOrderAPI.GetWorkOrderByID({ WorkOrderID: id }, (resp: any) => {
                if (resp.startDate) {
                    resp[`bind_startDate`] = moment.utc(resp.startDate).local().format("MM/DD/YY hh:mm a");
                }
                if (resp.endDate) {
                    resp[`bind_endDate`] = moment.utc(resp.endDate).local().format("MM/DD/YY hh:mm a");
                }
                if (resp.originalStartDate) {
                    resp[`bind_originalStartDate`] = moment.utc(resp.originalStartDate).local().format("MM/DD/YY hh:mm a");
                }
                if (resp.originalEndDate) {
                    resp[`bind_originalEndDate`] = moment.utc(resp.originalEndDate).local().format("MM/DD/YY hh:mm a");
                }
                resolve(resp);
            }, (error: any) => { 
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => {
            return null;
        });
        hideLoader();
        if (wodata && wodata.hasOwnProperty("workOrderID")) {
            setAssignwodatapreparation(wodata);
        } else {            
            toast.error("Task not found");
        }        
    };

    const onDragEnd = (result: DropResult) => {
        // Check edit permission first
        if (!canEdit) {
            toast.error("You don't have permission to modify work requests");
            return;
        }

        const { destination, source, draggableId } = result;    
        console.log("onDragEnd result =>", result);    
        if (!destination) return;
        var drop_col_id = +destination.droppableId.replace(/column-/g, ``);
        var source_col_id = +source.droppableId.replace(/column-/g, ``);
        console.log("drop_col_id =>", drop_col_id, "source_col_id =>", source_col_id);
        const alowed_dropzone:any = {
            1: [2, 6],
            2: [3, 4, 6],
            3: [4, 6],
            4: [5, 6],
            5: [6],
            6: []
        }   
        if (!alowed_dropzone[+source_col_id].includes(+drop_col_id)) return;     
        if (drop_col_id < source_col_id) return;
        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        switch (+drop_col_id) {
            case 2: {
                if (initialData.tasks[draggableId] && initialData.tasks[draggableId].content && initialData.tasks[draggableId].content.workRequestID) {
                    GetWorkRequestByID(initialData.tasks[draggableId].content.workRequestID)
                    createWODrwerWORef.current?.open();
                    console.log("Open Create Task Drawer", draggableId);
                }  else {
                    return toast.error("Work Request not found for this task");                
                }
                break;
            }
            case 3: 
            case 4: {
                console.log(draggableId, initialData.tasks[draggableId]);
                if (initialData.tasks[draggableId] && initialData.tasks[draggableId].content && initialData.tasks[draggableId].content.workOrderID) {
                    setIsAssignonly((+drop_col_id === 3)? true: false);
                    GetWorkOrderDetails(initialData.tasks[draggableId].content.workOrderID)
                    assignscheduleWODrwerWORef.current?.open();
                } else {
                    return toast.error("Task not found for this task");                
                }
                break;
            } 
            case 5: {
                console.log(draggableId, initialData.tasks[draggableId]);
                if (initialData.tasks[draggableId] && initialData.tasks[draggableId].content && initialData.tasks[draggableId].content.workOrderID) {
                    GetWorkOrderDetails(initialData.tasks[draggableId].content.workOrderID)
                    inprogressWODrwerWORef.current?.open();
                } else {
                    return toast.error("Task not found for this task");                
                }
                break;
            }
            case 6: {
                console.log(draggableId, initialData.tasks[draggableId]);
                if (+source_col_id === 1) {
                    if (initialData.tasks[draggableId] && initialData.tasks[draggableId].content && initialData.tasks[draggableId].content.workRequestID) {
                        setWillcancel(`wr`);
                        setCancelwrdatapreparation(initialData.tasks[draggableId].content);
                        if (closecancelmodalRef.current) {
                            closecancelmodalRef.current.selectedSourceCol = source_col_id;
                        }                    
                        closecancelmodalRef.current?.showModal();
                    }  else {
                        return toast.error("Work Request not found for this task");                
                    }
                } else {
                    if (initialData.tasks[draggableId] && initialData.tasks[draggableId].content && initialData.tasks[draggableId].content.workOrderID) {
                        setWillcancel(`wo`);
                        GetWorkOrderDetails(initialData.tasks[draggableId].content.workOrderID);                    
                        if (closecancelmodalRef.current) {
                            closecancelmodalRef.current.selectedSourceCol = source_col_id;
                        }                    
                        closecancelmodalRef.current?.showModal();
                        //completeincompleteWODrwerWORef?.current?.open();
                    }  else {
                        return toast.error("Task not found for this task");                
                    }
                }
                break;
            }
        }




        const start = data.columns[source.droppableId];
        const finish = data.columns[destination.droppableId];

        if (start === finish) {
            const newTaskIds = Array.from(start.taskIds);
            newTaskIds.splice(source.index, 1);
            newTaskIds.splice(destination.index, 0, draggableId);

            const newColumn = {
                ...start,
                taskIds: newTaskIds,
            };

            setData({
                ...data,
                columns: {
                    ...data.columns,
                    [newColumn.id]: newColumn,
                },
            });
            return;
        }

        // Moving from one column to another
        const startTaskIds = Array.from(start.taskIds);
        startTaskIds.splice(source.index, 1);
        const newStart = {
            ...start,
            taskIds: startTaskIds,
        };

        const finishTaskIds = Array.from(finish.taskIds);
        finishTaskIds.splice(destination.index, 0, draggableId);
        const newFinish = {
            ...finish,
            taskIds: finishTaskIds,
        };

        setData({
            ...data,
            columns: {
                ...data.columns,
                [newStart.id]: newStart,
                [newFinish.id]: newFinish,
            },
        });
    };

    const init_page_data = async() => {
        showLoader(); 
        
        // Fetching status list of kanban view
        const statusresp:any = await new Promise((resolve, reject) => {
            workRequestAPI.GetStatusList({}, (resp: any) => {
                if (resp && resp.hasOwnProperty(`workRequestStatusList`) && Array.isArray(resp.workRequestStatusList) && resp.workRequestStatusList.length > 0) {

                    console.log("Status list resp is -> ", resp.workRequestStatusList);

                   
                    resolve(resp.workRequestStatusList.map((status:any) => {
                         let WOSTATUSID = null;
                        switch (status.workRequestStatusID) {
                            case 1: WOSTATUSID = null; break;
                            case 2: WOSTATUSID = 1; break;
                            case 3: WOSTATUSID = 7; break;
                            case 4: WOSTATUSID = 2; break;
                            case 5: WOSTATUSID = 4; break;
                            case 6: WOSTATUSID = 5; break;
                        }
                        return { ...status, woStatusID: WOSTATUSID }

                    }));
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => {
            return [];
        });        
        setStatusList(statusresp);
        console.log("Status resp is -> ", statusresp);
        console.log("closefiltermode", closefiltermode);
        
        // Prepare API payload with filters
        let apiPayload: any = {
            //completionDate: closefiltermode? moment().subtract(+closefiltermode, `days`).utc().toISOString(): null,
            canAccessOwnOnly: false,
        };
        
        // Check if user can access only own work requests
        if (loggedinuser && getPermissionInfo(location.pathname, "Can Access Only Own Work Request", loggedinuser)) {
            apiPayload.canAccessOwnOnly = true;
        }
        
        // Add filters to API payload
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    apiPayload[key] = filters[key];
                }
            });
        }
        
        // Fetching kanban view data
         const kanbanresp:any = await new Promise((resolve, reject) => {
            workRequestAPI.GetListForKanbanView(apiPayload, (resp: any) => {
                console.log("Kanban resp is -> ", resp);
                if (resp && resp.hasOwnProperty(`kanbanViewList`) && Array.isArray(resp.kanbanViewList) && resp.kanbanViewList.length > 0) {
                    var bind_tasks: any = {};
                    var columns: any = {};
                    const tasks = resp.kanbanViewList.map((o:any, index:number) => {
                        o[`identifier`] = `task-${index}-${o.workRequestID}-${o.workOrderID || '0'}-${Math.random().toString().split(`.`)[1]}`;
                        bind_tasks[`${o.identifier}`] = {
                            id: o.identifier,
                            content: o,    
                        }
                        console.log('SSSSSSSSSSSSSSSS',o.workRequestStatusID)
                        return o;
                    });
                    const statusWisedata = statusresp.map((status:any) => {     
                        //console.log("woWorkOrderCode =>", status,  status.woWorkOrderCode, 'column title =>', getColumnTitle(status.workRequestStatusID, status.workRequestStatusName));                                                                    
                        //status[`dataset`] = resp.kanbanViewList.filter((item: any) => (item.workRequestStatusID == status.workRequestStatusID));
                        columns[`column-${status.workRequestStatusID}`] = {
                            id: `column-${status.workRequestStatusID}`,
                            title: getColumnTitle(status.workRequestStatusID, status.workRequestStatusName),  // Use custom mapping
                            dbid: status.workRequestStatusID,
                            workRequestStatusHexCode: status.workRequestStatusHexCode,
                            taskIds: tasks.filter((item: any) => (item.woStatusID == status.woStatusID)).map((o:any) => o.identifier),
                        };
                        return status;
                    }); 
                    console.log("columns =>", columns);  
                    resolve({
                        tasks: bind_tasks,
                        columns: columns,
                        resp: resp.kanbanViewList
                    });                    
                }  else {
                    resolve(null);
                }               
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => {
            return null;
        });

        if (kanbanresp) {
            initialData.columns = kanbanresp.columns;
            initialData.tasks = kanbanresp.tasks;            
            setData({...initialData});
        }
        console.log("kanbanresp", kanbanresp);
        hideLoader();
        setIsLoaded(true);
    };

    const onFilterData = (data:any = {}) => {
        console.log("Parent page filter data is -> ", data);    
    }

    const onCreateWR = async(e:any) => {
        console.log(e.detail.message);
        switch(e.detail.message.ACTION) {
            case `RELOAD`: {
                init_page_data();
                break;
            }
            case `FILTER`: {
               onFilterData(e.detail.message.data); 
               break;
            }
        }        
    };

    // Initialize filter options
    useEffect(() => {
        const payload = {};
        
        // Get facility list
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                        data: facilist
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
        
        // Get priority list
        workRequestAPI.GetPriorityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.workRequestPriorityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.workRequestPriorityName,
                        value: facilist.workRequestPriorityID,
                        data: facilist
                    });
                });
                setPriority(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    }, []);

    // Get users if not available
    useEffect(() => {
        if (users == null) {
            commonApi.GetUserList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [users]);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('workRequestKanbanFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('workRequestKanbanFilters', JSON.stringify(filters));
        }
    }, [filters]);

    // Initialize page data and filters
    useEffect(() => {
        if (filtersInitialized) {
            init_page_data();
        }
        window.addEventListener(`page_tab_WR_created`, onCreateWR);
        return () => {
            window.removeEventListener("page_tab_WR_created", onCreateWR);            
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        //init_page_data();
    }, [ closefiltermode ]);

    useEffect(() => {
        if (_ref?.current) {      
            _ref.current.reload = init_page_data;
            _ref.current.onFilterData = onFilterData
        }
    }, [_ref]);

    // Set filters applied state
    useEffect(() => {
        const filterConfig: filterConfigType[] = [
            { name: 'Facility', type: 'dropdown', key: 'facilityIDs', options: facilityoption || [] },
            { name: 'Priority', type: 'dropdown', key: 'priorityIDs', options: priority || [] },
            { name: 'Requester', type: 'dropdown', key: 'requesterIDs', options: users || [] },
        ];
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [filters, facilityoption, priority, users]);

    return (
        <>
            {/* Filter section for Kanban View */}
            <div className="bg-[#FAFAFA] flex justify-between px-5 py-2 items-center">
                {/* Left side buttons */}
                <div className="flex gap-4 items-center">
                    <Button
                        theme="light"
                        onClick={() => filtersRef.current.showModal()}
                    >
                        Filter{" "}
                        <Icon
                            name="filter"
                            size={1.4}
                            className={filtersApplied.generalFilter ? "text-blue-700" : ""}
                        />
                    </Button>
                    <p
                        className="text-primary font-semibold text-sm cursor-pointer"
                        onClick={() => {
                            setFilters({});
                            localStorage.removeItem('workRequestKanbanFilters');
                        }}
                    >
                        Clear Filters
                    </p>
                </div>
            </div>

            {isloaded && (
                <DragDropContext onDragEnd={onDragEnd}>
                    <div style={{ display: "flex", gap: 2, marginTop: `20px`, padding: `0 15px` }}>
                        {data.columnOrder.map((columnId) => {
                            const column = data.columns[columnId];
                            const tasks = column.taskIds.map((taskId) => data.tasks[taskId]);
                            const status = statusList.find((s) => +s.workRequestStatusID === +column.dbid);                    
                            return (
                                <KanbanColumn key={column.id} column={column} tasks={tasks} status={status} onFilter={setClosefiltermode} canEdit={canEdit} />
                            );
                        })}
                    </div>
                </DragDropContext>
            )}

            {/* Filters Modal */}
            <Filters 
                _ref={filtersRef} 
                config={[
                    { name: 'Facility', type: 'dropdown', key: 'facilityIDs', options: facilityoption || [] },
                    { name: 'Priority', type: 'dropdown', key: 'priorityIDs', options: priority || [] },
                    { name: 'Requester', type: 'dropdown', key: 'requesterIDs', options: users || [] },
                ]} 
                filters={filters} 
                onUpdate={(data: any) => {
                    setFilters(data);
                }} 
            />

            {/* Create Task Drawer */}
            <Drawer _ref={createWODrwerWORef} isAfterOpenRender={true} onClose={() => {                                
                createWODrwerWORef?.current?.close();
                init_page_data();
            }} outsideClose={false}>    
                <Drawer.Button></Drawer.Button>
                <Drawer.Content title={`Create New Task`} className='!w-[39.563rem]'>
                    <CreateWorkOrder _ref={createKBWORef} editData={null} WrID={``} prefillData={ creatwodatapreparation } onCreate={() => {                        
                        init_page_data();
                        createWODrwerWORef?.current?.close();
                    }} onCancel={() => { 
                        init_page_data();                       
                        createWODrwerWORef?.current?.close();
                    }} />
                </Drawer.Content>
            </Drawer>
                
            {/* Assign/Schedule Task Drawer */}
            <Drawer _ref={assignscheduleWODrwerWORef} isAfterOpenRender={true} onClose={() => {
              assignscheduleWODrwerWORef?.current?.close();
              setAssignwodatapreparation(null);
              init_page_data();
            }}
            outsideClose={false}
            >
                <Drawer.Button></Drawer.Button>
                <Drawer.Content title={isAssignonly? `Add Assigned`: `Add Scheduled`} className="!w-[45rem]"> {/*!w-[39.563rem]*/}              
                    <ScheduleModalWorkOrder _ref={assignscheduleKBRef} isAssignonly={ isAssignonly } editData={ assignwodatapreparation } currentStatus={isAssignonly? 7: 2} onCreate={() => {                  
                        assignscheduleWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();
                    }}
                    onCancel={() => {
                        assignscheduleWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();
                    }}
                />
                </Drawer.Content>
            </Drawer>

            {/* In proress Task Drawer */}
            <Drawer _ref={inprogressWODrwerWORef} isAfterOpenRender={true} onClose={() => {   
                inprogressWODrwerWORef?.current?.close();
                setAssignwodatapreparation(null);
                init_page_data();           
            }}  outsideClose={false}
            >
                <Drawer.Button></Drawer.Button>
                <Drawer.Content title={ `Workorder Overview (${assignwodatapreparation?.workOrderCode})` } className="!w-[45rem]">
                    {/*!w-[39.563rem]*/}
                    <InprogressModalWorkOrder _ref={inproressKBRef} currentStatus={4} editData={ assignwodatapreparation } onCreate={() => {
                        inprogressWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();           
                    }}
                    onCancel={() => {
                        inprogressWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();           
                    }}  
                    />
                </Drawer.Content>
            </Drawer>

            {/* Complete/In-Complete Task Drawer */}
            <Drawer _ref={completeincompleteWODrwerWORef} isAfterOpenRender={true} onClose={() => {   
                completeincompleteWODrwerWORef?.current?.close();
                setAssignwodatapreparation(null);
                init_page_data();           
            }}  outsideClose={false}
            >
                <Drawer.Button></Drawer.Button>
                <Drawer.Content title={ `Workorder Overview (${assignwodatapreparation?.workOrderCode})` } className="!w-[45rem]">
                    {/*!w-[39.563rem]*/}
                    <CompleteIncompleteModalWorkOrder _ref={completeincompleteKBRef} currentStatus={isComplete? 5: 6} editData={ assignwodatapreparation } onCreate={() => {
                        completeincompleteWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();           
                    }}
                    onCancel={() => {
                        completeincompleteWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();           
                    }}  
                    />
                </Drawer.Content>
            </Drawer>

            {/* Cancel Task Drawer */}
            <Drawer _ref={cancelWODrwerWORef} isAfterOpenRender={true} onClose={() => {                   
                setAssignwodatapreparation(null);
                cancelWODrwerWORef?.current?.close();
                init_page_data();                           
            }}  outsideClose={false}
            >
                <Drawer.Button></Drawer.Button>
                <Drawer.Content title={ `Workorder Overview (${assignwodatapreparation?.workOrderCode})` } className="!w-[45rem]">
                    {/*!w-[39.563rem]*/}
                    <CancelModalWorkOrder _ref={cancelKBRef} currentStatus={3} editData={ assignwodatapreparation } onCreate={() => {
                        cancelWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();           
                    }}
                    onCancel={() => {
                        cancelWODrwerWORef?.current?.close();
                        setAssignwodatapreparation(null);
                        init_page_data();           
                    }}  
                    />
                </Drawer.Content>
            </Drawer>
            
            {/* Cancel Work Request Drawer */}
            <Drawer _ref={cancelWRDrawerRef} isAfterOpenRender={true} onClose={() => {                   
                setCancelwrdatapreparation(null);
                cancelWRDrawerRef?.current?.close();
                init_page_data();                           
            }}  outsideClose={false}
            >
                <Drawer.Button></Drawer.Button>
                <Drawer.Content title={ `Workrequest Overview (${cancelwrdatapreparation?.workRequestCode})` } className="!w-[45rem]">
                    {/*!w-[39.563rem]*/}
                    <CancelWorkRequestSidebar _ref={cancelWRKBRef} currentStatus={6} editData={ cancelwrdatapreparation } onCreate={() => {
                        cancelWRDrawerRef?.current?.close();
                        setCancelwrdatapreparation(null);
                        init_page_data();           
                    }}
                    onCancel={() => {
                        cancelWRDrawerRef?.current?.close();
                        setCancelwrdatapreparation(null);
                        init_page_data();           
                    }}  
                    />
                </Drawer.Content>
            </Drawer>


            <dialog ref={closecancelmodalRef} className="modal">                
                <div className={ `modal-box max-w-[90%] p-4` } style={{ width: `35rem` }}>
                    <div className={ `flex items-center justify-between border-b border-[#dddcdc] pb-2 mb-2` }>
                        <p className={ `text-[1.063rem] text-[#755B51] font-semibold` }>Confirmation ({closecancelmodalRef && closecancelmodalRef.current?.selectedSourceCol && +closecancelmodalRef.current.selectedSourceCol != 1? assignwodatapreparation?.workOrderCode: cancelwrdatapreparation?.workRequestCode})</p>
                        <button type="button" className={ `bg-primary text-white p-1 rounded-md` } onClick={() => {
                            closecancelmodalRef.current.selectedSourceCol = null;
                            closecancelmodalRef.current?.close();
                            setAssignwodatapreparation(null);
                            setIsComplete(false);
                            init_page_data();
                        }}>                                
                            <Icon name='close' size={1.25} />                                                    
                        </button>
                    </div>
                    <div className={ `py-3 min-h-[14rem] flex flex-col items-center justify-center` }>
                        <p style={{ fontSize: 15 }}>
                            {closecancelmodalRef && closecancelmodalRef.current?.selectedSourceCol && [1,2,3,4].includes(+closecancelmodalRef.current.selectedSourceCol)? `Are you sure you want to cancel this Task?` : `What would you like to do with this Task?`}                            
                        </p>
                        <div className={ `flex items-center gap-2 mt-5` }>
                            {closecancelmodalRef && closecancelmodalRef.current?.selectedSourceCol && [5].includes(+closecancelmodalRef.current.selectedSourceCol) && (
                                <>
                                    <Button type="button" customstyle={{ background: `#2D6A32`, width: 170, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }} onClick={() => {
                                        setIsComplete(true);
                                        completeincompleteWODrwerWORef?.current?.open();
                                        closecancelmodalRef.current?.close();
                                    }}>Close-Complete</Button>
                                    <Button type="button" customstyle={{ background: `#cb833a`, width: 170, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }} onClick={() => {
                                        setIsComplete(false);
                                        completeincompleteWODrwerWORef?.current?.open();
                                        closecancelmodalRef.current?.close();
                                    }}>Close-Incomplete</Button>
                                    <Button type="button" theme={ `secondary` } customstyle={{ width: 170, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }} onClick={() => {
                                        setIsComplete(false);
                                        cancelWODrwerWORef?.current?.open();
                                        closecancelmodalRef.current?.close();
                                    }}>Cancel</Button>
                                </>
                            )}  
                            {closecancelmodalRef && closecancelmodalRef.current?.selectedSourceCol && [2,3,4].includes(+closecancelmodalRef.current.selectedSourceCol) && (
                                <>
                                    <Button type="button" theme={ `secondary` } customstyle={{ width: 170, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }} onClick={() => {
                                        cancelWODrwerWORef?.current?.open();
                                        closecancelmodalRef.current?.close();
                                    }}>Yes</Button>
                                    <Button type="button" customstyle={{ background: `#cb833a`, width: 120, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }} onClick={() => {
                                        setIsComplete(false);
                                        setAssignwodatapreparation(null);
                                        init_page_data();
                                        closecancelmodalRef.current?.close();
                                    }}>No</Button>
                                </>
                            )}

                            {closecancelmodalRef && closecancelmodalRef.current?.selectedSourceCol && [1].includes(+closecancelmodalRef.current.selectedSourceCol) && (
                                <>
                                    <Button type="button" theme={ `secondary` } customstyle={{ width: 170, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }} onClick={() => {
                                        setIsComplete(false);
                                        //Needs to open WR cancel popup/sidebar
                                        cancelWRDrawerRef?.current?.open();
                                        closecancelmodalRef.current?.close();
                                    }}>Yes</Button>
                                    <Button type="button" customstyle={{ background: `#cb833a`, width: 120, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }} onClick={() => {
                                        setIsComplete(false);                                        
                                        setCancelwrdatapreparation(null);
                                        init_page_data();
                                        closecancelmodalRef.current?.close();
                                    }}>No</Button>
                                </>
                            )}
                            
                        </div>
                    </div>                                                   
                </div>                
            </dialog>
            
        </>
    );
};

type KanbanColumnProps = {
    column: Column;
    //tasks: Task[];
    tasks: any[];
    status: any;
    onFilter?: (data: any) => void; 
    canEdit?: boolean;
};

const KanbanColumn: React.FC<KanbanColumnProps> = ({ column, tasks, status, onFilter = (data:any) => {}, canEdit = true }) => {
    
    const closefilterddcloser = useRef<HTMLButtonElement>(null);
    const closefilterdropdownRef = useRef<HTMLDivElement>(null);
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
    const [filtermode, setFilterMode] = useState<string | null>(null);

    return (
        <div className={`bg-[#fafafa] border border-[#D9D9D9] overflow-hidden rounded-[10px] h-full w-[270px]`}>
            <h3 style={{ borderTop: `3px solid ${column?.workRequestStatusHexCode || '#3333333'}`, borderRadius: `10px 10px 0 0`, borderBottom: `2px solid #DADADA`}} className={`bg-[#f0f0f0] font-semibold p-4 text-center relative`}>
                {column.title}
                {column.dbid === 6 && (
                    <span className={`text-[0.813rem] text-[#424242] ml-[5px] top-[15px] italic`}>Last 30 days</span>
                )}
            </h3>
            <Droppable droppableId={column.id}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{ background: (snapshot.isDraggingOver ? "#f4f5f7" : "#fafafa"), transition: "background 0.2s", height: "calc(100vh - 150px)" }}
                        className={`p-[10px] min-h-full rounded overflow-y-auto`}
                    >
                        {/*
                        {column.dbid === 6 && (
                            <div className={ `flex items-center justify-end mb-2 mx-[-10px] mt-[-10px] pt-0 text-[0.813rem] sticky top-[-10px] z-10 bg-white shadow` }>
                                 <div className="relative inline-block text-left" ref={closefilterdropdownRef}>
                                    <button onClick={() => setDropdownOpen((prev) => !prev)} className="inline-flex items-center gap-1 justify-center w-full px-4 py-1 rounded-md focus:outline-none">
                                        {(() => {
                                            switch(filtermode) {
                                                case `1`: {
                                                    return `Last 1 day`
                                                }
                                                case `7`: {
                                                    return `Last 7 days`
                                                }
                                                case `15`: {
                                                    return `Last 15 days`
                                                }
                                                case `30`: {
                                                    return `Last 1 month`
                                                }
                                                case `90`: {
                                                    return `Last 3 month`
                                                }
                                                default: {
                                                    return `Show all`
                                                }
                                            }                                                
                                        })()} <span style={{ marginTop: `-0.5px` }}><Icon name={ `bichevrondown` } size={ 1 } /></span>
                                    </button>

                                    {dropdownOpen && (
                                        <div className="absolute right-0 mt-1 w-[12.5rem] bg-white border border-gray-200 rounded-md shadow-lg z-50">
                                            <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => {
                                                setFilterMode(null);
                                                setDropdownOpen(false);
                                                onFilter(null)
                                            }}>Show all</a>
                                            <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => {
                                                setFilterMode(`1`);
                                                setDropdownOpen(false);
                                                onFilter(`1`)
                                            }}>Last 1 day</a>
                                            <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => {
                                                setFilterMode(`7`);
                                                setDropdownOpen(false);
                                                onFilter(`7`)
                                            }}>Last 7 days</a>
                                            <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"  onClick={() => {
                                                setFilterMode(`15`);
                                                setDropdownOpen(false);
                                                onFilter(`15`)
                                            }}>Last 15 days</a>
                                            <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"  onClick={() => {
                                                setFilterMode(`30`);
                                                setDropdownOpen(false);
                                                onFilter(`30`)   
                                            }}>Last 1 month</a>
                                            <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"  onClick={() => {
                                                setFilterMode(`90`);
                                                setDropdownOpen(false);
                                                onFilter(`90`)   
                                            }}>Last 3 month</a>
                                        </div>
                                    )}
                                </div>                                
                            </div>
                        )}
                        */}
                        {tasks && Array.isArray(tasks) && tasks.map((task, index) => (
                            <Draggable key={task.id} draggableId={task.id} index={index} isDragDisabled={!canEdit}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                            userSelect: "none",
                                            margin: "0 0 10px 0",
                                            background: snapshot.isDragging ? "#d2e3fc" : "#fff",
                                            borderRadius: 10,
                                            border: `1px solid #CECECE`,
                                            boxShadow: snapshot.isDragging
                                                ? "0 2px 8px rgba(0,0,0,0.15)"
                                                : "0 1px 2px rgba(0,0,0,0.05)",
                                            opacity: !canEdit ? 0.6 : 1,
                                            cursor: !canEdit ? "not-allowed" : "grab",
                                            ...provided.draggableProps.style,
                                        }}
                                        title={!canEdit ? "You don't have permission to move this item" : ""}
                                    >
                                        <div className={`flex items-center justify-between task-header`} style={{ borderBottom: `1px solid #CECECE`, padding: `15px`}}>
                                            <h4 className={`text-[15px] font-normal`}>
                                                {(() => {
                                                    if(+column.dbid === 6 && !task?.content?.woWorkOrderCode && task?.content?.workRequestCode) {
                                                        return <a href={ `/work-request/${task?.content?.workRequestID}`} target="_blank">{task?.content?.workRequestCode}</a>;
                                                    }
                                                    if (+column.dbid >= 2 && task?.content?.woWorkOrderCode) {                                                    
                                                        return <a href={ `/work-order/${task?.content?.workOrderID}`} target="_blank">{task?.content?.woWorkOrderCode}</a>;
                                                    }
                                                    if (+column.dbid < 2) {
                                                        return <>{task?.content?.workRequestCode? <a href={ `/work-request/${task?.content?.workRequestID}`} target="_blank">{task?.content?.workRequestCode}</a>: `--`}</>;
                                                    }
                                                })()}                                            
                                            </h4>
                                            <span style={{ width: `12px`, height: `12px`, borderRadius: `50px`, background: `${column?.workRequestStatusHexCode}`}}></span>
                                        </div>
                                        <div className={`p-[15px] task-content`}>
                                            <p className={`text-[15px] text-[#42484B] mb-3 line-clamp-2`} title={task?.content?.wrDescription}>{task?.content?.wrDescription}</p>
                                            <div className={`font-[15px] font-normal mb-2 line-clamp-1`} style={{ color: `#262A2D`}} title={task?.content?.wrFacilityName || `--`}>
                                                <label className={`font-medium`}>Facility:</label> {task?.content?.wrFacilityName || `--`}
                                            </div>
                                            <div className={`font-[15px] font-normal line-clamp-1`} style={{ color: `#262A2D`}} title={task?.content?.wrRequsterName || `--`}>
                                                <label className={`font-medium`}>Requester:</label> {task?.content?.wrRequsterName || `--`}
                                            </div>
                                        </div>                                    
                                        {+column.dbid >= 2 && task?.content?.workOrderID && (
                                            <div className={ `px-[15px] task-wo-created-content ${+column.dbid === 2? 'pb-[10px]': ''}`}>
                                                <div className={`font-[15px] font-normal mb-2`} style={{ color: `#262A2D`}}>
                                                    <label className={`font-medium`}>WR Number:</label> 
                                                    <div className={ `line-clamp-1` }>{task.content?.workRequestCode? <a href={ `/work-request/${task.content?.workRequestID}`} target="_blank">{task.content?.workRequestCode}</a>: `--`}</div>
                                                </div>
                                            </div>
                                        )}
                                        {+column.dbid >= 3 && task?.content?.workOrderID && (
                                            <div className={`p-[15px] task-assignee-content`} style={{ background: `#FAFAFA`, borderTop: `1px solid #CECECE`}}>
                                                <div className={`font-[15px] font-normal mb-2`} style={{ color: `#262A2D`}}>
                                                    <label className={`font-medium`}>Assignee Type:</label> {task?.content?.woAssignmentTypeName || `--`}
                                                </div>
                                                {+task?.content?.woAssignmentTypeID == 1 && (
                                                    <div className={`font-[15px] font-normal line-clamp-1`} style={{ color: `#262A2D`}}>
                                                        <label className={`font-medium`}>Assignee:</label> {task?.content?.woUserMappings || `--`}
                                                    </div>
                                                )}
                                                {+task?.content?.woAssignmentTypeID == 2 && (
                                                    <div className={`font-[15px] font-normal line-clamp-1`} style={{ color: `#262A2D`}}>
                                                        <label className={`font-medium`}>Assignee:</label> {task?.content?.woGrowerName || `--`}
                                                    </div>
                                                )}
                                                {+task?.content?.woAssignmentTypeID == 3 && (
                                                    <div className={`font-[15px] font-normal line-clamp-1`} style={{ color: `#262A2D`}}>
                                                        <label className={`font-medium`}>Assignee:</label> {task?.content?.woVendorName || `--`}
                                                    </div>
                                                )}                                            
                                            </div>
                                        )}
                                        {+column.dbid >= 4  && task?.content?.workOrderID && (
                                            <div className={`p-[15px] task-assignee-content`} style={{ background: `#F0F0F0`, borderTop: `1px solid #CECECE` }}>
                                                <div className={`font-[15px] font-normal mb-2`} style={{ color: `#262A2D`}} title={task?.content?.originalStartDate? moment.utc(task.content.originalStartDate).local().format(`MM/DD/YY`): `--`}>
                                                    <label className={`font-medium`}>Date:</label> {task?.content?.woStartDate? moment.utc(task.content.woStartDate).local().format(`MM/DD/YY`): `--`}
                                                </div>
                                                <div className={`font-[15px] font-normal`} style={{ color: `#262A2D`}} title={task?.content?.originalStartDate? moment.utc(task.content.originalStartDate).local().format(`hh:mm a`): `--`}>
                                                    <label className={`font-medium`}>Time:</label> {task?.content?.woStartDate? moment.utc(task.content.woStartDate).local().format(`hh:mm a`): `--`}
                                                </div>
                                            </div>
                                        )}
                                        {+column.dbid >= 6 && task?.content?.workOrderID && (
                                            <div className={`p-[15px] task-assignee-content`} style={{ background: `#E6E6E6`, borderTop: `1px solid #CECECE`, borderRadius: `0 0 10px 10px`}}>
                                                <div className={`font-[15px] font-normal mb-2`} style={{ color: `#262A2D`}}>
                                                    <label className={`font-medium`}>Closing Date:</label> {task?.content?.originalEndDate? moment.utc(task.content.originalEndDate).local().format(`MM/DD/YY`): `--`}
                                                </div>
                                                <div className={`font-[15px] font-normal`} style={{ color: `#262A2D`}}>
                                                    <label className={`font-medium`}>Closing Time:</label> {task?.content?.originalEndDate? moment.utc(task.content.originalEndDate).local().format(`hh:mm a`): `--`}
                                                </div>
                                            </div>                                            
                                        )}
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
};


export default KanbanView;